import React, { useState, useEffect } from "react";
import "./userProfileCamps.scss";
import { commonGetApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import Loader from "../../components/common/loader";

const getCampStatus = (start, end) => {
  const today = new Date();
  const startDate = new Date(start);
  const endDate = new Date(end);

  today.setHours(0, 0, 0, 0);
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  const dayMs = 24 * 60 * 60 * 1000;

  if (today > endDate) {
    return {
      text: "Completed",
      style: { background: "#ffebee", color: "#d32f2f" }
    };
  }

  if (today < startDate) {
    const daysToStart = Math.ceil(
      (startDate.getTime() - today.getTime()) / dayMs
    );

    return {
      text: `Starts in ${daysToStart} day${daysToStart === 1 ? "" : "s"}`,
      style: { background: "#fffde7", color: "#f9a825" }
    };
  }

  // Ongoing
  const daysLeft = Math.ceil(
    (endDate.getTime() - today.getTime()) / dayMs
  );

  return {
    text: `${daysLeft} day${daysLeft === 1 ? "" : "s"} left`,
    style: { background: "#d4f4e7", color: "#00c853" }
  };
};


const UserProfileCamps = () => {
  const [camps, setCamps] = useState([]);
  const [loader, setLoader] = useState(false);

  const getUserProfileForCamp = async () => {
    if (loader) return;
    setLoader(true);
    await commonGetApi(API_ENDPOINTS.GET_USER_PROFILE_FOR_CAMP).then((data) => {
      if (data?.status === 200) {
        setCamps(data?.data?.data);
      }
      setLoader(false);
    });
  };

  useEffect(() => {
    getUserProfileForCamp();
  }, []);

  if (loader) return <Loader />;

  return (
    <div className="user-profile-camps">
      {camps.map((camp) => {
        const status = getCampStatus(
          camp.START_DATE,
          camp.END_DATE
        );

        return (
          <div key={camp.id} className="camp-card">
          <div className="camp-card__header">
            <div className="camp-card__logo-section">
              <img
                src={
                  camp.LOGO
                    ? camp.LOGO
                    : require("../../assets/images/no-picture.jpg")
                }
                alt="Camp Logo"
                className="camp-card__logo"
                onError={(e) => {
                  e.target.src = require("../../assets/images/no-picture.jpg");
                }}
              />
              <div className="camp-card__title-section">
                <h3 className="camp-card__name">{camp.CAMP_NAME}</h3>
                <p className="camp-card__id">Camp ID: {camp.CAMP_ID}</p>
              </div>
            </div>
          </div>

          <div className="camp-card__details">
            <div className="camp-card__type-box">
              <p className="camp-card__type-label">Type</p>
              <p className="camp-card__type-value">{camp.CAMP_TYPE_NAME}</p>
            </div>
            <div className="camp-card__dates">
              <p className="camp-card__date-item">
                <span className="camp-card__date-label">Start Date:</span>{" "}
                <span className="camp-card__date-value">
                  {new Date(camp.START_DATE).toLocaleDateString()}
                </span>
              </p>
              <p className="camp-card__date-item">
                <span className="camp-card__date-label">End Date:</span>{" "}
                <span className="camp-card__date-value">
                  {new Date(camp.END_DATE).toLocaleDateString()}
                </span>
              </p>
            </div>
          </div>

          {/* Address Section */}
          <div className="camp-card__address">
            <span className="camp-card__address-label">Address : </span>
            {camp.FULL_ADDRESS}
          </div>

            {/* Footer */}
            <div className="camp-card__footer">
              <span className="camp-card__duration-label">
                Status:
              </span>

              <span
                className="camp-card__duration-badge"
                style={status.style}
              >
                {status.text}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UserProfileCamps;
